import { useMemo } from 'react';
import useComponentMountMetric from '../../metrics/useComponentMountMetric';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import { makeOptionsFromProperty } from 'customer-data-property-utils/PropertyValueDisplay';
import useOptionColors, { decoratorColorToTagMap } from '../../input/select/useOptionColors';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { jsx as _jsx } from "react/jsx-runtime";
export const FormattedPropertyMultiEnum = ({
  property,
  propertyValue,
  placeholder,
  dataAttributes
}) => {
  useComponentMountMetric('FormattedPropertyMultiEnum');
  const {
    shouldUseOptionColors,
    colorByOptionValue
  } = useOptionColors();
  const valueToTextMap = useMemo(() => {
    const options = makeOptionsFromProperty(property);
    return options.reduce((acc, option) => {
      const key = 'id' in option && option.id ? String(option.id) : String(option.value);
      acc[key] = option.text || key;
      return acc;
    }, {});
  }, [property]);
  const display = useMemo(() => {
    if (!propertyValue) {
      return placeholder;
    }
    const values = parseMultiEnumValue(propertyValue);
    if (shouldUseOptionColors) {
      return values.map((val, index) => {
        var _colorByOptionValue$v;
        if (val == null) {
          return null;
        }
        const optionText = valueToTextMap[val] || val;
        const tagColor = ((_colorByOptionValue$v = colorByOptionValue[val]) === null || _colorByOptionValue$v === void 0 ? void 0 : _colorByOptionValue$v.tagColor) || decoratorColorToTagMap.GRAY;
        return /*#__PURE__*/_jsx(Tag, {
          use: tagColor,
          "data-test-id": `tag-${tagColor}`,
          inline: true,
          children: optionText
        }, index);
      });
    } else {
      return values.map(val => {
        if (val == null) {
          return val;
        }
        const optionText = valueToTextMap[val] || val;
        return optionText;
      }).join(', ');
    }
  }, [propertyValue, placeholder, shouldUseOptionColors, colorByOptionValue, valueToTextMap]);
  return /*#__PURE__*/_jsx("span", Object.assign({}, dataAttributes, {
    children: display
  }));
};